import { trackDigitalEvent } from '@sparknz/tracking';

interface TrackAddToCartFailureProps {
  internalErrorCode: string;
  internalErrorMessage: string;
  errorMessage: string;
}

export const trackFailedLoginEvent = ({
  internalErrorCode,
  internalErrorMessage,
  errorMessage,
}: TrackAddToCartFailureProps) =>
  trackDigitalEvent({
    event: 'shop.addToCartAction',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Add to cart',
            eventAction: 'shop.addToCartAction',
          },
          attributes: {
            isSuccess: false,
            internalErrorCode,
            internalErrorMessage,
            errorMessage,
          },
        },
      ],
    },
  });
